import { createAsyncAction } from "typesafe-actions";
import * as types from "./types";

export const getJiraConnectionsAsync = createAsyncAction(
  types.JIRA_CONNECTIONS_LOADING,
  types.JIRA_CONNECTIONS_SUCCESS,
  types.JIRA_CONNECTIONS_ERROR
)<undefined, types.Connection[], string>();
